import { ProgramContentType } from "./BlockComponent";

export interface ProgramType {
  taskId: string;
  title?: string;
  content: ProgramContentType[];
  translationVersion?: string;
  thoughtRecordKey?: string;
}
export interface ProgramProgressType {
  moduleNumber: number;
  title: string;
  subtitle: string;
  taskIdPrefixList: string[];
}
export const ProgramProgressData = [
  {
    moduleNumber: 1,
    title: "패턴 찾아내기",
    subtitle: "일상에서 어떻게 불편함을 겪는지 알아봐요.",
    taskIdPrefixList: [
      "0-0",
      "1-1",
      "1-2",
      "2-1",
      "2-2",
      "0-1",
      "1-3",
      "3-2",
      "3-3",
    ],
  },
  {
    moduleNumber: 2,
    title: "생각 살펴보기",
    subtitle: "정확하지 않거나 도움이 되지 않는 생각을 다뤄요.",
    taskIdPrefixList: ["4-1", "4-2", "4-3", "4-4", "4-5"],
  },
  {
    moduleNumber: 3,
    title: "기꺼이 하기",
    subtitle: "나의 감정과 생각을 마주하고 그대로 경험해요.",
    taskIdPrefixList: ["5-1", "5-2", "5-3", "5-4", "5-5"],
  },
  {
    moduleNumber: 4,
    title: "뿌리 이해하기",
    subtitle: "나의 과거가 어떻게 오늘날을 만드는지 이해해요.",
    taskIdPrefixList: [
      "6-1",
      "6-2",
      "6-3",
      "6-4",
      "6-5",
      "6-6",
      "6-7",
      "6-8",
      "6-9",
      "6-10",
    ],
  },
  {
    moduleNumber: 5,
    title: "가치대로 살기",
    subtitle: "나의 가치에 맞게 행동하며 풍성한 삶을 만들어요.",
    taskIdPrefixList: [],
  },
];
export const TaskMetaData: { taskId: string; title: string }[] = [
  //0-0-A
  {
    taskId: "0-0-A",
    title: "디스턴싱 시작하기",
  },
  //0-1-A
  {
    taskId: "0-1-A",
    title: "부정적 반응 측정하기",
  },
  //0-2-A
  {
    taskId: "0-2-A",
    title: "부정적 반응 측정하기",
  },
  //0-3-A
  {
    taskId: "0-3-A",
    title: "이번 주 돌아보기",
  },
  //1-1-A
  {
    taskId: "1-1-A",
    title: "나의 고민과 목표",
  },
  //1-2-A
  {
    taskId: "1-2-A",
    title: "프로그램 구성하기",
  },
  //1-3-A
  {
    taskId: "1-3-A",
    title: "생각과 팝콘과 나",
  },
  //1-4-A
  {
    taskId: "1-4-A",
    title: "효과적이지 않은 대처",
  },
  //2-1-A
  {
    taskId: "2-1-A",
    title: "생각기록지 작성 연습하기",
  },
  //2-2-T
  {
    taskId: "2-2-T",
    title: "생각기록지",
  },
  //3-1-A
  {
    taskId: "3-1-A",
    title: "생각 지도",
  },
  //3-2-A
  {
    taskId: "3-2-A",
    title: "자동적인 생각",
  },
  //3-3-A
  {
    taskId: `3-3-A`,
    title: `자동적 사고 살펴보기`,
  },
  //4-1-A
  {
    taskId: "4-1-A",
    title: "생각함정",
  },
  //4-2-A
  {
    taskId: `4-2-A`,
    title: `다양한 관점에서 생각해보기`,
  },
  //4-3-1-A
  {
    taskId: `4-3-1-A`,
    title: `정확하지 않은 생각들`,
  },
  //4-3-2-A
  {
    taskId: `4-3-2-A`,
    title: `도움이 되지 않는 생각들`,
  },
  //4-4-1-A
  {
    taskId: `4-4-1-A`,
    title: `생각함정 1. 책임 과다`,
  },
  //4-4-2-A
  {
    taskId: `4-4-2-A`,
    title: `생각함정 2. 근거 부족`,
  },
  //4-4-3-A
  {
    taskId: `4-4-3-A`,
    title: `생각함정 3. 부정 편향`,
  },
  //4-4-4-A
  {
    taskId: `4-4-4-A`,
    title: `생각함정 4. 평가`,
  },
  //4-4-5-A
  {
    taskId: `4-4-5-A`,
    title: `생각함정 5. 개념화`,
  },
  //4-4-6-A
  {
    taskId: `4-4-6-A`,
    title: `생각함정 6. 반추`,
  },
  //4-5-1-A
  {
    taskId: `4-5-1-A`,
    title: `책임 과다 다루기`,
  },
  //4-5-2-A
  {
    taskId: `4-5-2-A`,
    title: `근거 부족 다루기`,
  },
  //4-5-3-A
  {
    taskId: `4-5-3-A`,
    title: `부정 편향 다루기`,
  },
  //4-5-4-A
  {
    taskId: `4-5-4-A`,
    title: `평가 다루기`,
  },
  //4-5-5-A
  {
    taskId: `4-5-5-A`,
    title: `개념화 다루기`,
  },
  //4-5-6-A
  {
    taskId: `4-5-6-A`,
    title: `반추 다루기`,
  },
  //5-1-A
  {
    taskId: `5-1-A`,
    title: `뇌의 재활훈련`,
  },
  //5-2-A
  {
    taskId: `5-2-A`,
    title: `기꺼이 하기`,
  },
  //5-3-A
  {
    taskId: `5-3-A`,
    title: `생각 바라보기`,
  },
  //5-4-A
  {
    taskId: `5-4-A`,
    title: `감정 바라보기`,
  },
  //5-5-A
  {
    taskId: `5-5-A`,
    title: `신체 감각 바라보기`,
  },
  //6-1-A
  {
    taskId: `6-1-A`,
    title: `생각 지도`,
  },
  //6-2-A
  {
    taskId: `6-2-A`,
    title: `중간 믿음`,
  },
  //6-3-A
  {
    taskId: `6-3-A`,
    title: `중간 믿음 살펴보기`,
  },

  //6-4-A
  {
    taskId: `6-4-A`,
    title: `핵심 믿음`,
  },
  //6-5-A 영구결번
  {
    taskId: `6-5-A`,
    title: `핵심 믿음 찾아보기`,
  },
  //6-6-A
  {
    taskId: `6-6-A`,
    title: `핵심 믿음 살펴보기`,
  },
  //6-7-A
  {
    taskId: `6-7-A`,
    title: `핵심 경험`,
  },
  //6-8-A
  {
    taskId: `6-8-A`,
    title: `핵심 경험 살펴보기`,
  },
  //6-9-A
  {
    taskId: `6-9-A`,
    title: `생각 지도 이해하기`,
  },
  //6-10-A
  {
    taskId: `6-10-A`,
    title: `지난 기록 돌아보기`,
  },

  //6-7-A => 6-97-A
  {
    taskId: `6-97-A`,
    title: `핵심 경험 찾아보기`,
  },
  //6-2-A => 6-98-A
  {
    taskId: `6-98-A`,
    title: `대처 전략 살펴보기`,
  },
  //6-3-A => 6-99-A
  {
    taskId: `6-99-A`,
    title: `대처 전략과 자동적 사고`,
  },
];
